import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const Nueve = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh'}}><b>Revenues</b></Paragraph>
        <Text className='BaseText2' style={{marginTop: '0%'}}>Currently these diagnostics are not accessible for everyone. Therefore, our main <b>revenue streams will be government aid, sponsors and pharmaceutical stakeholders. </b> By selling quick and accurate diagnostic tests we aim to empower the civil society and the health sector of our country.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-31-va-despu-s.png'/>
          <p><b>Fig. 6.9</b>  Complementary image of the <q>Revenues</q> section in the Business Model Canva </p>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Nueve;
